import React from 'react'
import { PlaceholderWrapper, Placeholder } from '../GameBoardStyles'
import { CardFront } from '../../card/CardFront'
import { calculateDelay } from '../../card/helpers/calculateDelay'
import { colors } from '../../../lib/colors'

export default function Player({
  cardsList,
  deal,
  dealOut,
  winPositions,
  showResult,
}: any) {
  return (
    <PlaceholderWrapper className='player'>
      {cardsList.map((card: any, id: any) => (
        <Placeholder key={id} zIndex={7 - id}>
          <CardFront
            card={card}
            deal={deal}
            dealOut={dealOut}
            animDelay={calculateDelay(id)}
            background={
              showResult && winPositions[id] === '1'
                ? colors.secondary
                : colors.cardWhite
            }
          />
        </Placeholder>
      ))}
    </PlaceholderWrapper>
  )
}
